import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-manage-templates',
  templateUrl: './manage-templates.component.html',
  styleUrls: ['./manage-templates.component.scss']
})
export class ManageTemplatesComponent implements OnInit {    
  currentUser: any;
  organizationId: string;
  databaseId:string;
  responseHolder: any;
  templateList: any=[]=[]; 
  templateListFilter: any=[]=[]; 
  value = '';
  filterText: any;
  paginatorTotalLength: any; 
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;
  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;
  formDialog: FormGroup;
  
   editType = {
    templateID: 0,   
    templateName: "",   
  }

  constructor(private loaderService: LoaderService, private toastr: ToastrService, private statusConst: StatusConstant,
     private reusableClass: ReusableClasses, private dialog: MatDialog, private settingsService: SettingService,
     private encryptionAlgo: EncryptionService,private formBuilder: FormBuilder) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
     var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
     let group = {};
     this.formDialog = new FormGroup(group);
     this.formDialog.addControl('templateName',this.formBuilder.control(''));    
     this.getAllTemplatestoManage();
  }


  
  getAllTemplatestoManage() {
    this.ShowNoRecordFound=false;
    this.loaderService.show();
    var ReqModel={
      userID: this.currentUser.UID,
      folderID: 0,
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }      
    this.settingsService.GetAllTemplatestoManage(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.templateList = this.responseHolder.data;
          this.templateListFilter = this.responseHolder.data;
          if(this.templateList!=null){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }    
        }
        else {
          this.templateList=[];         
          this.loaderService.hide();
        }
      }
      else {
        this.templateList=[];
        this.loaderService.hide();
      }
    });
  }

 

  deleteTemplate(temp: any) {
    var message = `Are you sure you want to delete template?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var ReqModel={
          userID: this.currentUser.UID,
          templateID: temp.templateID,
          officeID: this.myOfficeID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          officeIDList: this.OfficeIDList
         }
        this.settingsService.DeleteTemplate(ReqModel).subscribe(response => {
         if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == true) {
              this.toastr.success('Template deleted successfully.', '', {
                timeOut: 3000,
              });
              this.getAllTemplatestoManage();
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
  }


  close() {
    this.dialog.closeAll();
  }

  showOptions(event:MatCheckboxChange,data): void {
    var ReqModel={     
      templateID: Number(data.templateID),
      isDefualt: event.checked,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }      
    this.settingsService.setDefualtDocumentTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
           this.toastr.success('Record update successfully.', '', {
               timeOut: 3000,
           });
          this.getAllTemplatestoManage();
        }
        else {             
          this.loaderService.hide();
        }
      }
      else {       
        this.loaderService.hide();
      }
    });
  }

  onChangeCategory($event) {
    if($event.value == "All"){
       this.templateList=this.templateListFilter;
    }
    if($event.value == "Public"){
       this.templateList=this.templateListFilter.filter(x=>x.isPublic==true);
    }
    if($event.value == "Private"){
       this.templateList=this.templateListFilter.filter(x=>x.isPublic==false);
    }
  }

   openDialogWithRef(templateRef: TemplateRef<any>, type: any) {
       this.editType.templateID = type.templateID;
       this.editType.templateName = type.templateName;      
       this.dialog.open(templateRef, {
       });
       this.formDialog.markAsPristine();
   }


   spinner:boolean=false;

  UpdateTemplateName() {
    this.spinner=true;
    this.formDialog.markAsPristine();
    let type = this.editType;
    this.loaderService.show();
    var ReqModel = {
      templateID: type.templateID,          
      name: type.templateName,      
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),      
      officeID:this.myOfficeID,
      officeIDList:this.OfficeIDList,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.renameDocumentTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;
        this.responseHolder = response;
        if (this.responseHolder.data == true) {
          this.dialog.closeAll();
          this.toastr.success('Record updated successfully.', '', {
            timeOut: 3000,
          });
          this.getAllTemplatestoManage();
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
  }

  dropTemplate(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.templateList, event.previousIndex, event.currentIndex);
    var templateLists = [];
    if (this.templateList.length > 0) {
      for (let i = 0; i < this.templateList.length; i++) {
        var obj = {
          position: i + 1,          
          itemID: this.templateList[i].templateID,
        };
        templateLists.push(obj);
      }
    }
    this.loaderService.show();
    var ReqModel = {     
      items: templateLists,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.spinner = true;
    this.settingsService.reorderDocumentTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;
        this.responseHolder = response;
        if (this.responseHolder.data == true) {             
          this.getAllTemplatestoManage();
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
  }

  // Search(filterValue) {
  //   this.filterText = filterValue.trimLeft();
  //   this.pageModelData.tagName = filterValue.trim();
  //   this.getTagList(this.pageModelData);
  // }

  // clearFilter(){
  //   this.value = "";
  //   this.filterText = "";
  //   this.pageModelData.tagName = this.filterText.trim();
  //   this.getTagList(this.pageModelData);
  // }

  // CallNextPrevPageData(pageData: PageEvent) {
  //   this.currentData = pageData;
  //   this.pageModelData.pageIndex = pageData.pageIndex;
  //   this.pageModelData.pageSize = pageData.pageSize;
  //   this.pageModelData.tagName = this.value.trim();
  //   this.getTagList(this.pageModelData);
  // }

}